// Source: https://www.jayfreestone.com/writing/react-portals-with-hooks/

import { createPortal } from 'react-dom';
import usePortal from 'hooks/use-portal';
import React from 'react';

/**
 * @example
 * <Portal id="modal">
 *   <p>Thinking with portals</p>
 * </Portal>
 */
const Portal = ({ id, children }: { id: string; children: React.ReactNode }): any => {
  const target = usePortal(id);
  return createPortal(children, target);
};

export default Portal;
